/**
 * 主题配置文件
 *
 * 切换主题只需修改 CURRENT_THEME 的值：
 * - 'orange': 橙色主题（原主题）
 * - 'blue': 深蓝色主题（新主题，匹配蓝色Logo）
 * - 'purple': 晓元紫色主题（HopeAI 主题，匹配晓元主题色）
 */

export type ThemeType = 'orange' | 'blue' | 'purple';

// ========================================
// 👇 修改这里切换主题
// ========================================
export const CURRENT_THEME: ThemeType = 'purple';
// ========================================

/**
 * 主题配色方案
 */
export const THEME_COLORS = {
  orange: {
    name: '橙色主题',
    brand: '#ff6b35',
    brandHover: '#e55a2b',
    brandLight: '#fff5f0',
    brandWeb: '#c96442',
  },
  blue: {
    name: '深蓝色主题',
    brand: '#1e40af',
    brandHover: '#1e3a8a',
    brandLight: '#eff6ff',
    brandWeb: '#3b82f6',
  },
  purple: {
    name: '晓元紫色主题',
    brand: '#6d28d9',
    brandHover: '#5b21b6',
    brandLight: '#f5f3ff',
    brandWeb: '#7c3aed',
  },
} as const;

/**
 * 获取当前主题配色
 */
export const getCurrentThemeColors = () => THEME_COLORS[CURRENT_THEME];

/**
 * 应用主题到 document
 */
export const applyTheme = (theme: ThemeType = CURRENT_THEME) => {
  document.documentElement.setAttribute('data-theme', theme);
};
